import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../../../hooks";
import * as dashboardActions from "../../../redux/reducers/dashboardReducer";
import { userState } from "../../../redux/reducers/userReducer";

import delete_svg from "../../../assets/delete_svg.svg";
import edit_svg from "../../../assets/edit_svg.svg";
import ticketStarIcon from "../../../assets/ticketStarIcon.png";
import {
  TwButton,
  TwCalendarPicker,
  TwCheckBox,
  TwConfirmDialog,
  TwFormHelperText,
  TwInputGroup,
  TwLabel,
  TwSwitch,
  TwTimePicker,
  TwTooltip,
} from "../../../components/tailwind";
import TwDrawer from "../../../components/tailwind/TwDrawer";
import { loadingState } from "../../../redux/reducers/loadingReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForBookings } from "../../../utils/confighelpers";
import { defaultAvailablePaymentMethods } from "../../../utils/constants";
import PriceHelperText from "../../../components/PriceHelperText";
import { UsersIcon } from "@heroicons/react/16/solid";
import { InformationCircleIcon, PlusIcon } from "@heroicons/react/20/solid";
import { useToast } from "../../../provider/ToastProvider";
import moment from "moment";
import {
  isUnixTimestamp,
  decimalDisplayValue,
  decimalOnChange,
} from "../../../helpers";
import calender_black from "../../../assets/calender_black.svg";
import { useTranslation } from "react-i18next";

export default function PricingTab({
  profileFor,
  formValues,
  setFormValues,
  setTabCurrentState,
  edit = false,
  handleUpdate,
  isFromDetail = false,
  scheduleCreatAtDateTime = moment().unix(),
  scheduleStartDateTime = moment().unix(),
  scheduleEndDateTime = moment().unix(),
}) {
  const { t, i18n } = useTranslation();
  const { addConfirmDialog } = useToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingReduxState = useSelector(loadingState);
  function createData(
    ticketType,
    amount,
    capacity,
    minQtyPerOrder,
    absorbServiceFee,
    availableForSale,
  ) {
    return {
      ticketType,
      amount,
      capacity,
      minQtyPerOrder,
      absorbServiceFee,
      availableForSale,
    };
  }

  const handleFormValueChange = (event) => {
    const { name, value } = event.target;
    setFormPriceValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const userReduxState = useSelector(userState);
  const [isEdit, setIsEdit] = React.useState(-1);
  const [totalCapacity, setTotalCapacity] = React.useState(0);
  const [formPriceErrors, setFormPriceErrors] = React.useState({});
  const [formPriceValues, setFormPriceValues] = React.useState({
    ticketType: "",
    amount: 0,
    capacity: 0,
    minQtyPerOrder: 1,
    absorbServiceFee: false,
    availableForSale: true,
    includedAddons: [],
    // showOnStartDateTime: scheduleCreatAtDateTime,
    // showOnEndDateTime: scheduleEndDateTime
    isShowEndDateOnShop: false,
  });
  const [eventPricingList, setEventPricingList] = React.useState([]);
  const [addTicket, setAddTicket] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(false);
  const [contextMenuOpen, setContextMenuOpen] = React.useState(
    Boolean(anchorEl),
  );
  const [delDialogOpen, setDelDialogOpen] = React.useState(false);
  const [userToken] = useLocalStorage("userToken");
  const [availablePaymentMethods, setAvailablePaymentMethods] = React.useState(
    defaultAvailablePaymentMethods,
  );
  const [isAllowForPaidTicket, setIsAllowForPaidTicket] = React.useState(true);
  /**
   * Options an organizer can offer per included add-on.
   *
   * Grouped diet → religious → allergen/intolerance → medical, so the picker scans in a
   * predictable order. "No preference" stays LAST and its exact spelling matters: the
   * buyer-side `buildDefaultDietarySelections` looks it up by string, and the dashboard
   * dietary summary files unanswered attendees under the same label so an explicitly
   * chosen "No preference" and a skipped one land in one bucket.
   */
  const DIETARY_OPTIONS_LIST = [
    "Vegetarian", "Vegan", "Pescatarian",
    "Halal", "Kosher",
    "Gluten-free", "Dairy-free", "Nut-free", "Shellfish-free",
    "Alcohol-free", "Sugar-free (diabetic)", "Low sodium",
    "No preference",
  ];
  const [includeAddons, setIncludeAddons] = React.useState(false);
  const [includedAddons, setIncludedAddons] = React.useState([
    { addonName: "", qtyPerTicket: 1 },
  ]);
  // Collapsed by default. Only a ticket type that was SAVED with a sales period opens
  // expanded — see the edit handler, which sets this from the row rather than leaving
  // whatever the previously-opened row happened to set.
  const [isAdvanceSettings, setIsAdvanceSettings] = React.useState(false);
  const [isShowEndDateOnShop, setIsShowEndDateOnShop] = React.useState(false);

  const getAvailablePaymentMethods = async () => {
    const requestConfig = {
      method: "get",
      url: `${getUrlForBookings()}payments/getAvailablePaymentMethods?organizerId=${userReduxState.userData?._id}&paymentMethodsFor=event&bookingFor=event`,
    };
    const response = await axiosInstance(requestConfig);
    if (response.status === 200) {
      if (response.data.statusCode === 403) {
      } else if (response.data.statusCode === 200) {
        if (response.data.data) {
          setAvailablePaymentMethods({
            ...{
              payAtVenue: {
                enable: false,
                processingFeeApplicable: true,
                reserveNowPaylater: true,
                paymentGatewayServiceFee: {
                  paymentProcessingFlatFee: 0,
                  paymentProcessingPercentage: 0,
                },
              },
            },
            ...response.data.data,
          });
        }
      }
    }
  };

  const calculatbuyerCost = (amount, onlyServicefee = true) => {
    let defaultPercentage = 0;
    if (availablePaymentMethods?.bookzyPlatformFee) {
      let flatFee = 0;
      let percentageFee = 0;
      if (availablePaymentMethods?.bookzyPlatformFee?.flatFee > 0) {
        flatFee = availablePaymentMethods?.bookzyPlatformFee?.flatFee;
      }
      if (availablePaymentMethods?.bookzyPlatformFee?.percentageFee > 0) {
        percentageFee =
          availablePaymentMethods?.bookzyPlatformFee?.percentageFee;
      }
      return parseFloat(amount) > 0
        ? parseFloat(
            (onlyServicefee ? parseFloat(amount) : 0) +
              parseFloat(flatFee) +
              parseFloat(amount) * parseFloat(percentageFee / 100),
          ).toFixed(2)
        : 0;
    }
    return parseFloat(amount) > 0
      ? parseFloat(
          (onlyServicefee ? parseFloat(amount) : 0) +
            parseFloat(amount) * parseFloat(defaultPercentage / 100),
        ).toFixed(2)
      : 0;
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setContextMenuOpen(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setContextMenuOpen(null);
  };

  const handleDialogOpen = () => {
    handleClose();
    setDelDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDelDialogOpen(false);
  };

  const handleDelete = async (price) => {
    let pricesCopy = [...eventPricingList];
    if (Array.isArray(pricesCopy)) {
      pricesCopy = pricesCopy.filter((item) => item !== price);
    }
    setFormValues((prevValues) => ({
      ...prevValues,
      eventPricingList: [...pricesCopy],
    }));
    setEventPricingList((prevValues) => pricesCopy);
    setIsEdit(-1);
    handleDialogClose();
  };

  const clearForm = async () => {
    setFormPriceValues({
      ticketType: "",
      amount: "0",
      capacity: "0",
      minQtyPerOrder: "1",
      absorbServiceFee: false,
      availableForSale: true,
      includedAddons: [],
      // showOnStartDateTime: scheduleCreatAtDateTime,
      // showOnEndDateTime: scheduleEndDateTime
    });
    setIncludeAddons(false);
    setIsAdvanceSettings(false);
    setIsShowEndDateOnShop(false);
    setIncludedAddons([]);
    setFormPriceErrors({});
  };

  const handleSubmit = async () => {
    const errors = {};
    if (formValues.eventPricingList.length <= 0) {
      errors.eventPricingList = t("errors.addAtLeastOnePrice");
    }
    setFormPriceErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      return;
    }
    setTabCurrentState("3");
  };

  const addIncludedAddons = () => {
    const lastIncludedAddons = includedAddons[includedAddons.length - 1];
    const errors = {};
    const errorsIncludedAddons = [];

    if (includedAddons.length > 0) {
      if (
        lastIncludedAddons.addonName === undefined ||
        lastIncludedAddons.addonName === ""
        // || lastIncludedAddons.qtyPerTicket === undefined
        // || isNaN(lastIncludedAddons.qtyPerTicket)
      ) {
        errorsIncludedAddons.push(t("errors.completePreAddons"));
        // alert('Please complete the previous addons details before adding a new one.');
      }

      if (
        lastIncludedAddons.qtyPerTicket === undefined ||
        lastIncludedAddons.qtyPerTicket === "" ||
        isNaN(lastIncludedAddons.qtyPerTicket) ||
        parseInt(lastIncludedAddons.qtyPerTicket) <= 0 ||
        parseFloat(lastIncludedAddons.qtyPerTicket) % 1 !== 0
      ) {
        errorsIncludedAddons.push(t("errors.positiveQtyNumber"));
      }
      if (errorsIncludedAddons.length > 0) {
        errors.includedAddons = errorsIncludedAddons.join("\n");
      }

      setFormPriceErrors({ ...errors });
      if (Object.keys(errors).length > 0) {
        return;
      }
    }
    setIncludedAddons([...includedAddons, { addonName: "", qtyPerTicket: 1 }]);
  };

  const removeIncludedAddons = (index) => {
    const newIncludedAddons = [...includedAddons.filter((_, i) => i !== index)];
    setIncludedAddons(newIncludedAddons);
  };

  const handleIncludedAddonsChange = (index, field, value) => {
    const newIncludedAddons = [...includedAddons];
    // newIncludedAddons[index][field] = value;
    newIncludedAddons[index] = {
      ...newIncludedAddons[index],
      [field]: value,
    };
    setIncludedAddons(newIncludedAddons);
  };

  React.useEffect(() => {
    let totalCapacitys = 0;
    eventPricingList.forEach((element) => {
      totalCapacitys = totalCapacitys + parseInt(element.capacity);
    });
    setTotalCapacity(totalCapacitys);
    setFormValues((prevValues) => ({
      ...prevValues,
      seats: totalCapacitys,
    }));
  }, [eventPricingList]);

  React.useEffect(() => {
    if (edit && formValues?.editSubmit && formValues.editSubmit === true) {
      handleUpdate();
      setFormValues((prevValues) => ({
        ...prevValues,
        editSubmit: false,
      }));
    }
    setEventPricingList(formValues.eventPricingList);

    if (
      formPriceValues.includedAddons &&
      formPriceValues.includedAddons.length > 0
    ) {
      setIncludeAddons(true);
    }
  }, [formValues.eventPricingList]);

  React.useEffect(() => {
    setFormPriceValues((prevValues) => ({
      ...prevValues,
      includedAddons: includedAddons,
    }));
    if (
      formPriceValues.includedAddons &&
      formPriceValues.includedAddons.length > 0
    ) {
      setIncludeAddons(true);
    }
  }, [includedAddons]);

  React.useEffect(() => {
    let pricesCopy = [...formValues.eventPricingList];
    if (!formValues.eventPricingList.length) {
      // pricesCopy.push(createData("Free Addmission", "0", "10", false))
      setFormValues((prevValues) => ({
        ...prevValues,
        eventPricingList: pricesCopy,
      }));
    }
    setIsEdit(-1);
    setEventPricingList(pricesCopy);
    getAvailablePaymentMethods();
  }, []);

  React.useEffect(() => {
    setIsAllowForPaidTicket(true);
    if (
      userReduxState.userData?.myConnectedPaymentProfiles?.stripe &&
      userReduxState.userData?.myConnectedPaymentProfiles?.stripe
        ?.profileDetails?.stripeAcId &&
      userReduxState.userData?.myConnectedPaymentProfiles?.stripe
        ?.profileDetails?.stripeAcId !== "" &&
      parseFloat(formPriceValues.amount) > 0
    ) {
      setIsAllowForPaidTicket(false);
    }
  }, [isEdit]);

  /**
   * Warn when renaming an included add-on on a ticket type that already has bookings.
   *
   * Included add-ons have no stable id — the NAME is the identity. Existing tickets keep
   * whatever name they were sold under, so renaming "Dinnee" to "Dinner" leaves the
   * dashboard dietary summary reporting two separate items forever. Correcting a typo is
   * exactly when an organizer does this, and it's silent otherwise.
   *
   * Only fires when it actually matters: editing a saved ticket type, the name differs
   * from the stored one, and at least one confirmed booking exists to be orphaned.
   */
  const savedTicketBeingEdited =
    isEdit >= 0 ? formValues.eventPricingList?.[isEdit] : null;
  const confirmedBookingsForTicket = parseInt(
    savedTicketBeingEdited?.ticketsBooked?.ticketsBookedConfirmed || 0,
  );

  const isIncludedAddonRenamed = (index, currentName) => {
    if (!savedTicketBeingEdited || confirmedBookingsForTicket <= 0) return false;

    const savedName = String(
      savedTicketBeingEdited?.includedAddons?.[index]?.addonName || "",
    ).trim();
    const nextName = String(currentName || "").trim();

    // An add-on added during this edit has no saved name to diverge from.
    if (!savedName || !nextName) return false;
    return savedName.toLowerCase() !== nextName.toLowerCase();
  };

  return (
    <div
      className={`flex flex-col gap-4 ${edit === false ? "py-6" : ""}  ${isFromDetail === false ? "sm:px-8 [sm:w-4/5]" : ""}`}
    >
      <div
        className={`flex flex-col gap-4 ${edit === false ? "p-6 border-2 border-bright-gray rounded-2xl mt-5" : ""}`}
      >
        <div className={"flex gap-2 items-center w-full"}>
          <div
            className={`items-left ${edit === false ? "my-5" : ""} w-full ${isFromDetail === false ? "text-base sm:text-2xl" : "text-2xl sm:text-3xl"}`}
          >
            {t("myEvents.eventTickets")}
            {/* {t("myEvents.totalCapacity")} {totalCapacity} */}
          </div>
          <div
            className={`flex justify-end w-full ${edit === false ? "mt-5" : ""}`}
          >
            <TwButton
              variant={"default-box"}
              className="truncate"
              onClick={() => {
                clearForm();
                setAddTicket(true);
              }}
            >
              <PlusIcon className="size-5" />
              &nbsp;&nbsp;{t("myEvents.addTicketType")}
            </TwButton>
          </div>
        </div>
        <div className="overflow-x-auto">
          <div className="inline-block min-w-full py-2 align-middle sm:px-1 overflow-x-auto">
            <div className="overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-form">
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      {t("myEvents.ticketType")}
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {t("myEvents.price")}
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {t("myEvents.capacity")}
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {t("myEvents.ticketsSold")}
                    </th>
                    <th
                      scope="col"
                      className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                    >
                      <span className="sr-only">
                        {t("account.tableActionHead")}
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {eventPricingList.length > 0 ? (
                    eventPricingList.map((row, i) => (
                      <tr key={i}>
                        <td className="whitespace-nowrap py-5 pt-6 pl-4 pr-3 text-sm font-bold text-gray-900 sm:pl-6 flex gap-2 items-center align-middle">
                          {row.ticketType}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold">
                          <div>
                            €{row.amount}
                            <p className="text-sm text-gray-400">
                              {t("myEvents.costToBuyer")} €
                              {row.absorbServiceFee === true
                                ? parseFloat(row.amount)
                                : calculatbuyerCost(row.amount)}
                            </p>
                          </div>
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold">
                          <div>
                            {row.capacity}
                            <p className="text-sm text-gray-400">
                              {row.capacity}/{totalCapacity}
                            </p>
                          </div>
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold">
                          <div>
                            {row?.ticketsBooked?.ticketsBookedConfirmed || 0}/
                            {row.capacity}
                          </div>
                        </td>
                        <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                          <div className="flex gap-2 justify-center items-center">
                            <button
                              onClick={() => {
                                setIsEdit(i);
                                setFormPriceValues({
                                  availableForSale: true,
                                  includedAddons: [],
                                  ...row,
                                  // showOnStartDateTime: row.showOnStartDateTime != undefined ? (isUnixTimestamp(row.showOnStartDateTime) ? row.showOnStartDateTime : moment(row.showOnStartDateTime).unix()) : scheduleCreatAtDateTime,
                                  // showOnEndDateTime: row.showOnEndDateTime != undefined ? (isUnixTimestamp(row.showOnEndDateTime) ? row.showOnEndDateTime : moment(row.showOnEndDateTime).unix()) : scheduleEndDateTime,
                                });
                                setIncludedAddons([
                                  ...(row?.includedAddons || []),
                                ]);
                                setAddTicket(true);

                                // Assign on BOTH branches. The old code only ever set this
                                // to true, so opening a ticket that had a sales period and
                                // then opening one that didn't left the section expanded
                                // with dates the second ticket never had.
                                const hasSalesPeriod =
                                  row.showOnStartDateTime != undefined &&
                                  row.showOnEndDateTime != undefined;
                                setIsAdvanceSettings(hasSalesPeriod);
                                setIsShowEndDateOnShop(
                                  hasSalesPeriod
                                    ? row?.isShowEndDateOnShop || false
                                    : false,
                                );
                              }}
                              className="size-7"
                            >
                              <TwTooltip title={t("inputFieldsTitle.edit")}>
                                <img
                                  src={edit_svg}
                                  alt={t("inputFieldsTitle.edit")}
                                  className="size-7"
                                />
                              </TwTooltip>
                            </button>
                            <button
                              onClick={() => {
                                // setIsEdit(i);
                                setIsEdit(-1);
                                setFormPriceValues({
                                  availableForSale: true,
                                  includedAddons: [],
                                  ...row,
                                });
                                setIncludedAddons([
                                  ...(row?.includedAddons || []),
                                ]);
                                setAddTicket(true);
                              }}
                              className="size-7"
                            >
                              <TwTooltip title={"Duplicate Ticket"}>
                                <svg
                                  className={"text-secondary"}
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4M10 8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V10C8 8.89543 8.89543 8 10 8Z"
                                    stroke="currentColor"
                                    strokeWidth="1"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </TwTooltip>
                            </button>
                            <button
                              onClick={() => {
                                setIsEdit(i);
                                handleDialogOpen();
                              }}
                              className="size-7"
                            >
                              <TwTooltip title={t("inputFieldsTitle.delete")}>
                                <img
                                  src={delete_svg}
                                  alt={t("inputFieldsTitle.delete")}
                                  className="size-7"
                                />
                              </TwTooltip>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={5}
                        className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center"
                      >
                        {t("myEvents.noTicketsCreated")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* <div className={`text-left w-full text-sm text-indigo-bz`}>
          {t("myEvents.totalCapacity")} {totalCapacity}
        </div> */}
        {formPriceErrors["eventPricingList"] && (
          <TwFormHelperText error={true}>
            {formPriceErrors["eventPricingList"]}
          </TwFormHelperText>
        )}
      </div>
      {isFromDetail === false ? (
        <div className={"flex gap-3 justify-center items-center pt-12 sm:px-8"}>
          <TwButton
            variant={"secondary-outline"}
            className={"w-full sm:w-60"}
            disabled={loadingReduxState.actionLoading}
            onClick={() => {
              if (edit) {
                dispatch(dashboardActions.setCalendarSessionId(-1));
                dispatch(dashboardActions.setCalendarOpen(false));
                navigate("/home/dashboard");
              } else {
                setTabCurrentState("1");
              }
            }}
          >
            {edit ? t("inputFieldsTitle.cancel") : t("inputFieldsTitle.back")}
          </TwButton>
          <TwButton
            variant={"secondary"}
            className={"w-full sm:w-60"}
            disabled={loadingReduxState.actionLoading}
            actionLoading={loadingReduxState.actionLoading}
            onClick={() => {
              if (edit) {
                handleUpdate();
              } else {
                handleSubmit();
              }
            }}
          >
            {edit ? t("update") : t("inputFieldsTitle.continue")}
          </TwButton>
        </div>
      ) : (
        ""
      )}
      <TwConfirmDialog
        dialogOpen={delDialogOpen}
        dialogType="error"
        dialogTitle={t("myEvents.deleteTicketTypeTitle")}
        dialogMessage={t("myEvents.deleteTicketTypeSubTitle")}
        onClose={async () => {
          handleDialogClose(false);
        }}
        onConfirm={async () => {
          handleDelete(eventPricingList[isEdit]);
        }}
      />
      <TwDrawer
        title={`${isEdit >= 0 ? t("update") : t("myEvents.add")} ${t("myEvents.tickets")}`}
        classNameDialogPanel={`!max-w-md`}
        open={addTicket}
        onClose={() => {
          setIsEdit(-1);
          clearForm();
          setAddTicket(false);
        }}
        footerChildren={
          <>
            <TwButton
              variant={"secondary-outline"}
              disabled={loadingReduxState.actionLoading}
              onClick={() => {
                setIsEdit(-1);
                setTimeout(() => {
                  clearForm();
                }, 1000);
                setAddTicket(false);
              }}
            >
              {t("inputFieldsTitle.cancel")}
            </TwButton>
            <TwButton
              variant={"secondary"}
              disabled={loadingReduxState.actionLoading}
              actionLoading={loadingReduxState.actionLoading}
              onClick={() => {
                const errors = {};
                if (!formPriceValues.ticketType) {
                  errors.ticketType = t("errors.required");
                } else {
                  eventPricingList.map((row, i) => {
                    if (
                      isEdit !== i &&
                      formPriceValues.ticketType === row.ticketType
                    ) {
                      errors.ticketType = t("errors.notAllowSameTicketType");
                    }
                    return row;
                  });
                }
                if (formPriceValues.amount < 0) {
                  errors.amount = t("errors.required");
                }
                if (formPriceValues.absorbServiceFee === true && parseFloat(formPriceValues.amount) > 0) {
                  const serviceFee = parseFloat(calculatbuyerCost(formPriceValues.amount, false));
                  if (parseFloat(formPriceValues.amount) < serviceFee) {
                    errors.amount = t("errors.priceLessThanServiceFee", { serviceFee: `€${serviceFee}` });
                  }
                }
                if (formPriceValues.capacity <= 0) {
                  errors.capacity = t("errors.required");
                }
                if (formPriceValues.capacity % 1 !== 0) {
                  errors.capacity = t("errors.decimalValueOnly");
                }

                if (
                  formPriceValues.showOnStartDateTime != undefined &&
                  formPriceValues.showOnEndDateTime != undefined
                ) {
                  if (
                    formPriceValues.showOnStartDateTime >
                    formPriceValues.showOnEndDateTime
                  ) {
                    errors.showOnStartDateTime = t(
                      "myEvents.startDateTimeBeforeEndTime",
                    );
                    errors.showOnEndDateTime = t(
                      "myEvents.endDateTimeAfterStartTime",
                    );
                  }
                }

                if (isEdit >= 0) {
                  let ticketDetail = formValues.eventPricingList.find(
                    (d, i) => isEdit === i,
                  );
                  if (
                    ticketDetail &&
                    ticketDetail?.capacity != undefined &&
                    ticketDetail?.ticketsBooked &&
                    ticketDetail.ticketsBooked.ticketsBookedConfirmed !=
                      undefined &&
                    parseInt(formPriceValues.capacity) <
                      parseInt(
                        ticketDetail.ticketsBooked.ticketsBookedConfirmed,
                      )
                  ) {
                    errors.capacity = t("myEvents.minCapacityOfTicket");
                  }
                }

                const errorsIncludedAddons = [];

                for (let i = 0; i < includedAddons.length; i++) {
                  const tier = includedAddons[i];
                  const { addonName, qtyPerTicket, commissionPerTicket } = tier;

                  if (addonName === undefined || addonName == "") {
                    errorsIncludedAddons.push(
                      t("myEvents.addonNameErrorMsg", { number: i + 1 }),
                    );
                  }

                  if (
                    qtyPerTicket === undefined ||
                    (qtyPerTicket !== undefined &&
                      (isNaN(qtyPerTicket) || parseInt(qtyPerTicket) <= 0))
                  ) {
                    // errorsIncludedAddons.push(`Addon ${i + 1}: "Qty" must be a positive number and greater than "0"`);
                    errorsIncludedAddons.push(
                      t("myEvents.addonQtyErrorMsg", { number: i + 1 }),
                    );
                  }
                }

                if (errorsIncludedAddons.length > 0) {
                  errors.includedAddons = errorsIncludedAddons.join("\n");
                }

                setFormPriceErrors({ ...errors });
                if (Object.keys(errors).length > 0) {
                  return;
                }
                let pricesCopy = [];
                if (isEdit >= 0) {
                  pricesCopy = eventPricingList.map((row, i) => {
                    if (isEdit === i) {
                      return formPriceValues;
                    }
                    return row;
                  });
                } else {
                  pricesCopy = [...eventPricingList, formPriceValues];
                }
                let finalPrices = pricesCopy.map((d) => {
                  let newData = {
                    ...d,
                    availableForSale:
                      d.availableForSale !== undefined
                        ? d.availableForSale
                        : true,
                    includedAddons:
                      d.includedAddons !== undefined ? d.includedAddons : [],
                  };
                  if (newData?.ticketsBooked) {
                    delete newData?.ticketsBooked;
                  }
                  if (newData?.showOnStartDateTime != undefined) {
                    if (
                      isUnixTimestamp(newData?.showOnStartDateTime) == false
                    ) {
                      newData.showOnStartDateTime = moment(
                        newData?.showOnStartDateTime,
                      ).unix();
                    }
                  }
                  if (newData?.showOnEndDateTime != undefined) {
                    if (isUnixTimestamp(newData?.showOnEndDateTime) == false) {
                      newData.showOnEndDateTime = moment(
                        newData?.showOnEndDateTime,
                      ).unix();
                    }
                  }
                  return newData;
                });
                setIsEdit(-1);
                setEventPricingList(finalPrices);
                setFormValues((prevValues) => ({
                  ...prevValues,
                  eventPricingList: finalPrices,
                  ...edit ? { editSubmit: true } : {},
                }));
                setTimeout(() => {
                  clearForm();
                }, 1000);
                setAddTicket(false);
              }}
            >
              {isEdit >= 0 ? t("update") : t("myEvents.addTicket")}
            </TwButton>
          </>
        }
      >
        <div className="flex flex-col gap-3">
          <TwInputGroup
            label={t("myEvents.ticketType")}
            placeholder={t("myEvents.ticketType")}
            name={"ticketType"}
            leftIcon={<img className="size-5" alt="" src={ticketStarIcon} />}
            value={formPriceValues.ticketType}
            onChange={handleFormValueChange}
            errors={formPriceErrors}
            className="!py-3 md:pl-2.5"
            helperText={t("myEvents.ticketTypeHelperText")}
          />
          <div className="flex gap-2 items-center">
            <TwInputGroup
              // label={t("myEvents.price")}
              label={
                <span className="inline-flex items-center gap-1">
                  {t("myEvents.price")}
                  <TwTooltip
                    position={"right"}
                    title={t("myEvents.priceTooltipTitle")}
                  >
                    <InformationCircleIcon className="size-4 text-gray-400 cursor-pointer" />
                  </TwTooltip>
                </span>
              }
              placeholder={t("myEvents.price")}
              type={"text"}
              inputMode="decimal"
              name={"amount"}
              leftIcon={"€"}
              disabled={isAllowForPaidTicket}
              value={decimalDisplayValue(formPriceValues.amount, i18n.language)}
              onChange={(event) => {
                const parsed = decimalOnChange(
                  event.target.value,
                  i18n.language,
                );
                if (parsed !== null) {
                  setFormPriceValues((prevValues) => ({
                    ...prevValues,
                    amount: parsed,
                  }));
                }
              }}
              errors={formPriceErrors}
              className="!py-3 md:pl-2.5"
              helperText={
                <PriceHelperText
                  t={t}
                  amount={formPriceValues.amount}
                  serviceFee={calculatbuyerCost(formPriceValues.amount, false)}
                  absorbServiceFee={formPriceValues.absorbServiceFee === true}
                />
              }
            />
            <TwCheckBox
              title={t("myEvents.free")}
              name={"isfree"}
              checked={isAllowForPaidTicket}
              // disabled={isAllowForPaidTicket}
              onChange={(e) => {
                const { name, value, checked } = e.target;

                if (
                  userReduxState.userData?.myConnectedPaymentProfiles?.stripe &&
                  userReduxState.userData?.myConnectedPaymentProfiles?.stripe
                    ?.profileDetails?.stripeAcId &&
                  userReduxState.userData?.myConnectedPaymentProfiles?.stripe
                    ?.profileDetails?.stripeAcId !== "" &&
                  userReduxState.userData?.myConnectedPaymentProfiles?.stripe
                    ?.profileDetails?.stripeOnBoardindStatus &&
                  userReduxState.userData?.myConnectedPaymentProfiles?.stripe
                    ?.profileDetails?.stripeOnBoardindStatus === "SUCCESS"
                ) {
                  setIsAllowForPaidTicket(checked);
                  if (checked === true) {
                    setFormPriceValues((prevValues) => ({
                      ...prevValues,
                      amount: 0,
                    }));
                  }
                } else {
                  addConfirmDialog({
                    dialogOpen: true,
                    dialogType: "warning",
                    dialogTitle: t("myEvents.paymentNotEnabledTitle"),
                    dialogMessage: t("myEvents.paymentNotEnabledSubTitle"),
                    isCloseBtn: false,
                    btnCloseText: t("inputFieldsTitle.close"),
                    btnConfirmVariant: "secondary",
                    btnConfirmText: t("myEvents.paymentNotEnabledBtn"),
                    onClose: async () => {
                      // window.location.href = "/on-bording/payment-setup";
                    },
                    onConfirm: async () => {
                      window.open(`/my-account/online-payment`, "_blank");
                      // navigate("/my-account/online-payment", { replace: true });
                    },
                  });
                }
              }}
              errors={formPriceErrors}
            />
          </div>
          <TwCheckBox
            label={t("myEvents.absorbServiceFee")}
            title={t("myEvents.absorbServiceFee")}
            name={"absorbServiceFee"}
            checked={formPriceValues.absorbServiceFee || false}
            onChange={(e) => {
              const { name, value, checked } = e.target;

              if (checked && parseFloat(formPriceValues.amount) > 0) {
                const serviceFee = parseFloat(calculatbuyerCost(formPriceValues.amount, false));
                if (parseFloat(formPriceValues.amount) < serviceFee) {
                  setFormPriceErrors((prev) => ({
                    ...prev,
                    amount: t("errors.priceLessThanServiceFee", { serviceFee: `€${serviceFee}` }),
                  }));
                  return;
                }
              }

              setFormPriceErrors((prev) => {
                const { amount, ...rest } = prev;
                return rest;
              });

              setFormPriceValues((prevValues) => ({
                ...prevValues,
                absorbServiceFee: checked,
              }));
            }}
            errors={formPriceErrors}
          />
          <TwInputGroup
            label={
              <span className="inline-flex items-center gap-1">
                {t("myEvents.minimumBookingQty")}
                <TwTooltip
                  title="Set to 2 for couple deals, 4+ for group deals. Each person gets their own QR code. Guests buy in multiples of this number."
                  position="top"
                >
                  <InformationCircleIcon className="size-4 text-gray-400 cursor-pointer" />
                </TwTooltip>
              </span>
            }
            placeholder={t("myEvents.minimumBookingQty")}
            type={"number"}
            name={"minQtyPerOrder"}
            leftIcon={<img className="size-5" alt="" src={ticketStarIcon} />}
            value={formPriceValues.minQtyPerOrder}
            onChange={handleFormValueChange}
            errors={formPriceErrors}
            className="!py-3 md:pl-2.5"
            helperText={t("myEvents.minimumBookingQtyHelperText")}
          />
          <TwInputGroup
            label={t("myEvents.capacity")}
            placeholder={t("myEvents.capacity")}
            type={"number"}
            name={"capacity"}
            leftIcon={<UsersIcon className="size-5 text-gray-400" />}
            value={formPriceValues.capacity}
            onChange={handleFormValueChange}
            errors={formPriceErrors}
            className="!py-3 md:pl-2.5"
            helperText={t("myEvents.capacityHelperText")}
          />
          <TwCheckBox
            label={t("myEvents.availableForSale")}
            title={t("myEvents.availableForSale")}
            name={"availableForSale"}
            checked={
              formPriceValues.availableForSale !== undefined
                ? formPriceValues.availableForSale
                : true
            }
            onChange={(e) => {
              const { name, value, checked } = e.target;

              setFormPriceValues((prevValues) => ({
                ...prevValues,
                availableForSale: checked,
              }));
            }}
            errors={formPriceErrors}
          />
          {/* {includeAddons == true && includedAddons && includedAddons.length > 0 ? ( */}

          <div className="border-b border-gray-900/10 my-3"></div>
          <TwSwitch
            title={
              <>
                {t("myEvents.addIncludedItemsTitle")}{" "}
                <TwLabel>
                  <span className="italic">
                    {t("myEvents.addIncludedItemsSubTitle")}
                  </span>
                  <br />
                  {t("myEvents.addIncludedItemsSubTitle2")}{" "}
                </TwLabel>
              </>
            }
            name={"includeAddons"}
            checked={includeAddons}
            onChange={(checked) => {
              if (includedAddons && includedAddons.length <= 0) {
                setIncludedAddons([{ addonName: "", qtyPerTicket: 1 }]);
              }
              if (!checked) {
                setIncludedAddons([]);
              }
              setIncludeAddons(!includeAddons);
            }}
          />
          {
            includeAddons == true ? (
              <div className="flex flex-col gap-3">
                {/* <TwLabel><span className="italic">{t("myEvents.addIncludedItemsSubTitle")}</span><br/>
                {t("myEvents.addIncludedItemsSubTitle2")} </TwLabel> */}
                {includedAddons.map((includedAddon, index) => (
                  <div key={index} className="flex flex-col gap-2 border border-gray-200 rounded-xl p-3">
                    <div className="flex gap-2 items-center">
                      <div className="w-full flex flex-col gap-0.5">
                        <TwLabel className="text-xs">
                          {t("myEvents.addonName")}
                        </TwLabel>
                        <input
                          type="text"
                          title={t("myEvents.addonName")}
                          placeholder={t("myEvents.addonName")}
                          className="mt-1 w-full rounded-2xl border border-gray-300 p-2 focus:ring-black focus:border-black"
                          value={includedAddon.addonName}
                          onChange={(e) =>
                            handleIncludedAddonsChange(
                              index,
                              "addonName",
                              e.target.value,
                            )
                          }
                        />
                        {isIncludedAddonRenamed(index, includedAddon.addonName) ? (
                          <p className="mt-1 text-xs text-amber-700">
                            {t(
                              "myEvents.includedAddonRenameWarning",
                              'Tickets already sold keep the name "{{savedName}}". Reports will show the old and new name as two separate items.',
                              {
                                savedName:
                                  savedTicketBeingEdited?.includedAddons?.[index]
                                    ?.addonName || "",
                              },
                            )}
                          </p>
                        ) : null}
                      </div>
                      <div>
                        <TwLabel className="text-xs">&nbsp;</TwLabel>-
                      </div>
                      <div className="w-2/12 flex flex-col gap-0.5">
                        <TwLabel className="text-xs">{t("myEvents.qty")}</TwLabel>
                        <input
                          type="number"
                          placeholder={t("myEvents.qty")}
                          className="mt-1 w-full rounded-2xl border border-gray-300 p-2 focus:ring-black focus:border-black"
                          value={includedAddon.qtyPerTicket}
                          onChange={(e) =>
                            handleIncludedAddonsChange(
                              index,
                              "qtyPerTicket",
                              parseInt(e.target.value),
                            )
                          }
                        />
                      </div>
                      <div className="flex flex-col gap-0.5">
                        <TwLabel className="text-xs">&nbsp;</TwLabel>
                        <button
                          onClick={() => removeIncludedAddons(index)}
                          className={includedAddons.length > 0 ? "" : "hidden"}
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                    {/* Dietary preference toggle */}
                    <div className="flex items-center gap-2 mt-1">
                      <TwCheckBox
                        checked={includedAddon.dietaryEnabled === true}
                        onChange={(e) =>
                          handleIncludedAddonsChange(index, "dietaryEnabled", e.target.checked)
                        }
                      />
                      <TwLabel className="text-xs">
                        Enable dietary preference
                      </TwLabel>
                    </div>
                    {includedAddon.dietaryEnabled && (
                      <div className="flex flex-wrap gap-2 mt-1">
                        {DIETARY_OPTIONS_LIST.map((opt) => {
                          const selected = (includedAddon.dietaryOptions || []).includes(opt);
                          return (
                            <button
                              key={opt}
                              type="button"
                              onClick={() => {
                                const current = includedAddon.dietaryOptions || [];
                                const updated = selected
                                  ? current.filter((o) => o !== opt)
                                  : [...current, opt];
                                handleIncludedAddonsChange(index, "dietaryOptions", updated);
                              }}
                              className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${
                                selected
                                  ? "bg-black text-white border-black"
                                  : "bg-white text-gray-600 border-gray-300 hover:border-gray-400"
                              }`}
                            >
                              {opt}
                            </button>
                          );
                        })}
                      </div>
                    )}
                  </div>
                ))}
                {formPriceErrors.includedAddons && (
                  <TwFormHelperText error={formPriceErrors.includedAddons}>
                    {formPriceErrors.includedAddons}
                  </TwFormHelperText>
                )}
                <div className=" flex">
                  <button
                    type="button"
                    onClick={addIncludedAddons}
                    className="text-sm text-blue-600 hover:underline"
                  >
                    {t("myEvents.addMore")}
                  </button>
                </div>
              </div>
            ) : null
            // (
            //   <button
            //         ])
            //       }
            //       setIncludeAddons(true);
            //     }}
            //   >
            //     <PlusIcon className='size-5' />&nbsp;&nbsp;Include Addons
            //   </button>)
          }

          <div className="border-b border-gray-900/10 my-3"></div>
          <TwSwitch
            title={t("myEvents.advanceSettings")}
            name={"isAdvanceSettings"}
            checked={isAdvanceSettings}
            onChange={(checked) => {
              if (
                formPriceValues.showOnStartDateTime == undefined ||
                formPriceValues.showOnEndDateTime == undefined
              ) {
                setFormPriceValues((prevValues) => ({
                  ...prevValues,
                  // showOnStartDateTime: date !== null ? date.toUnix() : "",
                  showOnStartDateTime:
                    formPriceValues.showOnStartDateTime != undefined
                      ? isUnixTimestamp(formPriceValues.showOnStartDateTime)
                        ? formPriceValues.showOnStartDateTime
                        : moment(formPriceValues.showOnStartDateTime).unix()
                      : scheduleCreatAtDateTime,
                  showOnEndDateTime:
                    formPriceValues.showOnEndDateTime != undefined
                      ? isUnixTimestamp(formPriceValues.showOnEndDateTime)
                        ? formPriceValues.showOnEndDateTime
                        : moment(formPriceValues.showOnEndDateTime).unix()
                      : scheduleEndDateTime,
                }));
              }
              if (checked == false) {
                setFormPriceValues((prevValues) => ({
                  ...prevValues,
                  showOnStartDateTime: undefined,
                  showOnEndDateTime: undefined,
                }));
              }
              setIsAdvanceSettings(!isAdvanceSettings);
            }}
          />
          {isAdvanceSettings == true ? (
            <>
              {/* The toggle says "Advanced settings", which doesn't say what it controls.
                  These four pickers are one thing: when this ticket type is on sale. */}
              <div className="mt-2">
                <p className="text-sm font-semibold text-gray-900">
                  {t("myEvents.salesPeriod", "Sales period")}
                </p>
                <p className="text-xs text-gray-400 mt-0.5">
                  {t(
                    "myEvents.salesPeriodHelper",
                    "When this ticket type can be bought. Outside these dates it is hidden from the shop.",
                  )}
                </p>
              </div>
              <div className="flex gap-2">
                <TwCalendarPicker
                  // format="ddd, DD MMM YYYY hh:mm A"
                  outerContainerClassName="sm:!w-full"
                  format="ddd, DD MMM YYYY"
                  label={t("myEvents.startTime")}
                  name={"showOnStartDateTime"}
                  value={moment
                    .unix(formPriceValues.showOnStartDateTime)
                    .toDate()}
                  minDate={moment
                    .unix(scheduleCreatAtDateTime)
                    .set({ hours: 0, minutes: 0 })
                    .toDate()}
                  maxDate={moment.unix(scheduleStartDateTime).toDate()}
                  leftIcon={
                    <img className={""} src={calender_black} alt={""} />
                  }
                  onChange={(date, dateParams) => {
                    setFormPriceValues((prevValues) => ({
                      ...prevValues,
                      showOnStartDateTime: date !== null ? date.toUnix() : "",
                    }));
                  }}
                />
                <TwTimePicker
                  outerContainerClassName="sm:!w-2/3"
                  format="HH:mm"
                  label={t("myEvents.time")}
                  name={"showOnStartDateTime"}
                  value={moment
                    .unix(formPriceValues.showOnStartDateTime)
                    .toDate()}
                  minDate={moment
                    .unix(scheduleCreatAtDateTime)
                    .set({ hours: 0, minutes: 0 })
                    .toDate()}
                  maxDate={moment.unix(scheduleStartDateTime).toDate()}
                  leftIcon={
                    <svg
                      className={"[size-5 sm:size-4]"}
                      width="18"
                      height="18"
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.11692 12.978C2.73828 12.978 0 10.2397 0 6.86106C0 3.48242 2.73828 0.744141 6.11692 0.744141C9.49556 0.744141 12.2338 3.48242 12.2338 6.86106C12.2338 10.2397 9.49556 12.978 6.11692 12.978ZM5.54346 6.86106C5.54346 7.05221 5.63904 7.23142 5.79913 7.31744L8.09297 8.84667C8.35581 9.0426 8.71183 8.97092 8.86714 8.70808C9.06308 8.44525 8.99139 8.08922 8.72856 7.91241L6.69038 6.55521V3.61145C6.69038 3.29365 6.43471 3.03799 6.09542 3.03799C5.79913 3.03799 5.52195 3.29365 5.52195 3.61145L5.54346 6.86106Z"
                        fill="#000"
                      />
                    </svg>
                  }
                  onChange={(date, dateParams) => {
                    setFormPriceValues((prevValues) => ({
                      ...prevValues,
                      showOnStartDateTime: date !== null ? date.toUnix() : "",
                    }));
                  }}
                />
              </div>
              {formPriceErrors["showOnStartDateTime"] && (
                <TwFormHelperText error={true}>
                  {formPriceErrors["showOnStartDateTime"]}
                </TwFormHelperText>
              )}
              <div className="flex gap-2">
                <TwCalendarPicker
                  outerContainerClassName="sm:!w-full"
                  format="ddd, DD MMM YYYY"
                  label={t("myEvents.endDate")}
                  name={"showOnEndDateTime"}
                  value={moment
                    .unix(formPriceValues.showOnEndDateTime)
                    .toDate()}
                  minDate={moment.unix(scheduleCreatAtDateTime).toDate()}
                  maxDate={moment.unix(scheduleStartDateTime).toDate()}
                  leftIcon={
                    <img className={""} src={calender_black} alt={""} />
                  }
                  onChange={(date, dateParams) => {
                    setFormPriceValues((prevValues) => ({
                      ...prevValues,
                      showOnEndDateTime: date.toUnix(),
                    }));
                  }}
                />
                <TwTimePicker
                  outerContainerClassName="sm:!w-2/3"
                  format="HH:mm"
                  label={t("myEvents.time")}
                  name={"showOnEndDateTime"}
                  value={moment
                    .unix(formPriceValues.showOnEndDateTime)
                    .toDate()}
                  minDate={moment.unix(scheduleCreatAtDateTime).toDate()}
                  maxDate={moment.unix(scheduleStartDateTime).toDate()}
                  leftIcon={
                    <svg
                      className={"[size-5 sm:size-4]"}
                      width="18"
                      height="18"
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.11692 12.978C2.73828 12.978 0 10.2397 0 6.86106C0 3.48242 2.73828 0.744141 6.11692 0.744141C9.49556 0.744141 12.2338 3.48242 12.2338 6.86106C12.2338 10.2397 9.49556 12.978 6.11692 12.978ZM5.54346 6.86106C5.54346 7.05221 5.63904 7.23142 5.79913 7.31744L8.09297 8.84667C8.35581 9.0426 8.71183 8.97092 8.86714 8.70808C9.06308 8.44525 8.99139 8.08922 8.72856 7.91241L6.69038 6.55521V3.61145C6.69038 3.29365 6.43471 3.03799 6.09542 3.03799C5.79913 3.03799 5.52195 3.29365 5.52195 3.61145L5.54346 6.86106Z"
                        fill="#000"
                      />
                    </svg>
                  }
                  onChange={(date, dateParams) => {
                    setFormPriceValues((prevValues) => ({
                      ...prevValues,
                      showOnEndDateTime: date.toUnix(),
                    }));
                  }}
                />
              </div>
              {formPriceErrors["showOnEndDateTime"] && (
                <TwFormHelperText error={true}>
                  {formPriceErrors["showOnEndDateTime"]}
                </TwFormHelperText>
              )}
              <div className="flex gap-2">
                <TwSwitch
                  title={t("myEvents.showEndDateOnShop")}
                  name={"isShowEndDateOnShop"}
                  checked={formPriceValues?.isShowEndDateOnShop || false}
                  onChange={(checked) => {
                    setFormPriceValues((prevValues) => ({
                      ...prevValues,
                      isShowEndDateOnShop: !isShowEndDateOnShop,
                    }));
                    // setIsShowEndDateOnShop(!isShowEndDateOnShop);
                  }}
                />
              </div>
            </>
          ) : null}
        </div>
      </TwDrawer>
    </div>
  );
}
